import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import { config } from "../../../config";
import { features } from "../../../features";
import { nonDefaultSearchParams } from "../../../utils/browserQueryParams";
import { moment } from "../../../utils/moment";
import { slugify } from "../../../utils/string";
import { Container } from "../../Container";
import { mapMediaToTeasers } from "../../ContentBlocks/CarouselBlock/CarouselBlock.state";
import { CarouselBlockWidget } from "../../ContentBlocks/CarouselBlock/CarouselBlock.widget";
import { VideoBlock } from "../../ContentBlocks/VideoBlock/VideoBlockLayout";
import { Link } from "../../Link";
import { Notice } from "../../Notice";
import { Tags } from "../../Tags";
import { Text } from "../../Text";
import { asPrice, formatDatesOverview, pushEventAction } from "../EventUtils";
import { Collapsible } from "./Collapsible";
import { extractSingles, linkFor } from "./EventDetailsUtils";
import { EventFilters } from "./EventFilters/EventFiltersLayout";
import { initialDetailFilters } from "./EventFilters/EventFiltersState";
import { EventMetaCard } from "./EventMetaCard";
const React = require("react");
const fallbackImage = {
    Original: '',
    Teaser: '',
    Teaser2x: '',
    Header: '',
    Header2x: '',
    Fallback: '',
    AltText: '',
    Caption: ''
};
export const EventDetailsLayout = (props)=>{
    var _event_PrimaryText, _event_Tags;
    const config = features().events;
    if (config == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const fallbackToHeader = config.detailPage.fallbackToHeaderAsPrimary;
    const customClassNames = config.detailPage.classNames.page;
    const { Jumbo, event, notice, filters } = props;
    const { Supertitle, Title, Subtitle, SecondaryText, Kind, SiblingEvents, ChildEvents, Status, Video, AdditionalMedia } = event;
    const { Header, Header2x, AltText, Original, Fallback } = event.Image || fallbackImage;
    // Not all libraries currently use the PrimaryText field, so if it's empty we fall back to the HeaderText.
    // This should be a temporary measure, but we all know how that usually goes. :P
    const [HeaderText, PrimaryText] = fallbackToHeader && !((_event_PrimaryText = event.PrimaryText) === null || _event_PrimaryText === void 0 ? void 0 : _event_PrimaryText.Content.trim()) ? [
        undefined,
        event.HeaderText
    ] : [
        event.HeaderText,
        event.PrimaryText
    ];
    document.title = Title;
    if (Subtitle) document.title += ` - ${Subtitle}`;
    const singles = List(extractSingles(ChildEvents ?? [])).sortBy((e)=>e.Start).toArray();
    const push = pushEventAction();
    const classNames = [
        'event-page',
        `event-page--${Status}`,
        `event-page--${Kind}`
    ].concat(singles.length > 0 ? [
        'event-page--has-moments'
    ] : []).concat(customClassNames(event)).join(' ');
    const backLinkUrl = `${config.prefix}${nonDefaultSearchParams(filters, initialDetailFilters)}`;
    const backLink = /*#__PURE__*/ _jsx("nav", {
        className: "event-page__breadcrumbs",
        children: /*#__PURE__*/ _jsxs(Link, {
            className: "back-link",
            url: backLinkUrl,
            handle: ()=>{
                push("Terug naar de agenda", Title);
            },
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    className: "chevron-left",
                    width: "1.5rem",
                    height: "1.5rem",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("use", {
                        xlinkHref: "#icon--chevron-left-large"
                    })
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: "Terug naar de agenda"
                })
            ]
        })
    });
    const filterByRegion = config.overviewPage.locationFilter.kind == 'region';
    const allEventLocations = List(singles).flatMap((e)=>e.Locations ?? []).toSet();
    const locationOptions = filterByRegion ? allEventLocations.filter((l)=>l.Region).map((l)=>l.Region).toSet() : allEventLocations.map((l)=>l.Name).toSet();
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames,
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                topContent: backLink,
                supertitle: Supertitle,
                title: Title,
                subtitle: Subtitle,
                imageUrl: Header,
                imageUrlFallback: Fallback,
                imageUrlLarge: Header2x,
                imageAlt: AltText,
                size: props.eventsOverviewClassNames.jumboSize,
                contents: /*#__PURE__*/ _jsx(_Fragment, {
                    children: Text(HeaderText)
                })
            }, slugify(Original)),
            singles.length > 0 && locationOptions.size > 1 && /*#__PURE__*/ _jsx("div", {
                className: "event-page__filter-bar",
                children: /*#__PURE__*/ _jsx(Container, {
                    size: "m",
                    gutter: true,
                    children: /*#__PURE__*/ _jsx(EventFilters, {
                        filters: filters,
                        locations: locationOptions
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(Container, {
                size: "m",
                gutter: true,
                className: "event-page__content",
                children: [
                    notice && /*#__PURE__*/ _jsx(Notice, {
                        ...notice
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "event-page__columns",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "event-page__main",
                                children: [
                                    (PrimaryText === null || PrimaryText === void 0 ? void 0 : PrimaryText.Content) && (config.detailPage.collapsePrimaryContent ? /*#__PURE__*/ _jsx(Collapsible, {
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            ...PrimaryText
                                        })
                                    }) : /*#__PURE__*/ _jsx(Text, {
                                        ...PrimaryText
                                    })),
                                    ((_event_Tags = event.Tags) === null || _event_Tags === void 0 ? void 0 : _event_Tags.length) > 0 && /*#__PURE__*/ _jsx(Tags, {
                                        items: event.Tags,
                                        className: "event-page__tags"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("aside", {
                                className: "event-page__aside",
                                children: /*#__PURE__*/ _jsx(EventMetaCard, {
                                    event: event
                                })
                            })
                        ]
                    }),
                    (SiblingEvents === null || SiblingEvents === void 0 ? void 0 : SiblingEvents.length) > 0 && seriesAlternatives(SiblingEvents),
                    singles.length > 0 && listEvents(filters, singles),
                    (Video === null || Video === void 0 ? void 0 : Video.Url) && /*#__PURE__*/ _jsx(VideoBlock, {
                        video: Video
                    }),
                    (AdditionalMedia === null || AdditionalMedia === void 0 ? void 0 : AdditionalMedia.length) > 0 && /*#__PURE__*/ _jsx(CarouselBlockWidget, {
                        items: mapMediaToTeasers(AdditionalMedia)
                    }),
                    (SecondaryText === null || SecondaryText === void 0 ? void 0 : SecondaryText.Content) && /*#__PURE__*/ _jsx(Text, {
                        ...SecondaryText
                    })
                ]
            })
        ]
    }, props.eventId);
};
const priceLines = (event, noTicketRequired)=>{
    var _event_Tickets;
    return ((_event_Tickets = event.Tickets) === null || _event_Tickets === void 0 ? void 0 : _event_Tickets.length) > 0 ? event.Tickets.map((t)=>[
            t.Cost ? asPrice(t.Cost) : null,
            t.Description || null
        ].filter((part)=>part).join(', ')).filter((line)=>line) : [
        noTicketRequired
    ];
};
const seriesAlternatives = (events)=>{
    const publishedEvents = events.filter((e)=>e.Status == 'published');
    if (publishedEvents.length == 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("hr", {}),
            /*#__PURE__*/ _jsxs(Container, {
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        children: "Andere activiteiten in deze reeks:"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "events__grid",
                        "data-columns": "1",
                        children: publishedEvents.map((e)=>/*#__PURE__*/ _jsx(React.Fragment, {
                                children: /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsxs(Link, {
                                        className: "link link--primary link--arrow",
                                        ...linkFor(e),
                                        children: [
                                            e.Title,
                                            e.Subtitle && ` - ${e.Subtitle}`,
                                            " op ",
                                            moment(e.Start).calendar(),
                                            locationStringFromEvent(e, ', ')
                                        ]
                                    })
                                })
                            }, e.PrefixedId))
                    })
                ]
            })
        ]
    });
};
const listEvents = (filters, events)=>{
    const singles = List(extractSingles(events)).sortBy((e)=>e.Start).toList();
    return /*#__PURE__*/ _jsx(SimpleList, {
        filters,
        events: singles
    });
};
const SimpleList = (props)=>{
    const { filters, events } = props;
    const config = features().events;
    if (config == 'off' || events.size == 0) return /*#__PURE__*/ _jsx(_Fragment, {});
    const pageSize = config.detailPage.pageSize;
    const [visibleMoments, setVisibleMoments] = React.useState(pageSize);
    const showMoreMoments = ()=>setVisibleMoments((v)=>v + pageSize);
    const { locationFilter } = config.overviewPage;
    const filterByRegion = locationFilter.kind == 'region';
    const selectedAreas = new Set(filterByRegion ? filters.regions : filters.locations);
    const eventLocations = (e)=>e.Locations.map((l)=>filterByRegion ? l.Region : l.Name);
    const areaFilter = (e)=>selectedAreas.size === 0 || eventLocations(e).some((loc)=>selectedAreas.has(loc));
    const dateFilter = (e)=>{
        if (!filters.from && !filters.to) return true;
        if (filters.from && e.Start < filters.from) return false;
        if (filters.to && e.Start > filters.to) return false;
        return true;
    };
    const filteredEvents = events.filter(areaFilter).filter(dateFilter);
    return /*#__PURE__*/ _jsxs("div", {
        className: "events-list events-list--moments",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "events-list__title",
                children: "Volgende momenten"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "events-list__items",
                children: filteredEvents.slice(0, visibleMoments).map((e)=>/*#__PURE__*/ _jsx(ChildEventLayout, {
                        event: e,
                        isCancelled: e.Status !== 'published'
                    }, `event-${e.Id}`))
            }),
            filteredEvents.size > visibleMoments && /*#__PURE__*/ _jsx("div", {
                className: "events-list__more",
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "button button--primary",
                    onClick: showMoreMoments,
                    children: "Toon meer momenten"
                })
            })
        ]
    });
};
// Description doubles as price info and is already shown in the price line, so a single free ticket gets a
// plain call to action. With several tickets the description keeps them distinguishable; paid tickets keep
// their own wording since "Meld je aan" reads wrong when payment is required.
const ticketLabel = (t, ticketCount)=>{
    var _t_Description;
    return ticketCount == 1 && !t.Cost ? 'Meld je aan' : ((_t_Description = t.Description) === null || _t_Description === void 0 ? void 0 : _t_Description.trim()) || (t.Cost ? 'Koop ticket' : 'Meld je aan');
};
const ItemTickets = (p)=>{
    const { arrowIconId } = config().ui;
    return p.Status == 'published' && p.Tickets && p.Tickets.length > 0 && /*#__PURE__*/ _jsx("div", {
        className: `event__tickets ${p.className || ''}`,
        children: p.Tickets.map((t, i)=>/*#__PURE__*/ _jsxs(Link, {
                className: "button button--primary button--event-ticket event__ticket",
                url: t.Uri,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "ticket__description",
                        children: ticketLabel(t, p.Tickets.length)
                    }),
                    /*#__PURE__*/ _jsx("svg", {
                        className: "event__ticket-icon",
                        width: "16",
                        height: "16",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ _jsx("use", {
                            xlinkHref: arrowIconId
                        })
                    })
                ]
            }, `ticket-${p.Id}-${i}`))
    });
};
const locationStringFrom = function(loc) {
    let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', includeRegion = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!loc) {
        console.warn('[EventDetailsLayout:locationStringFrom] No location found for event');
        return '';
    }
    let location = '';
    if (loc === null || loc === void 0 ? void 0 : loc.Name) {
        location = `${prefix}${loc.Name}`;
        if (includeRegion && loc.Region && !location.toLocaleLowerCase().includes(loc.Region.toLocaleLowerCase())) {
            location = `${location} (${loc.Region})`;
        }
    }
    return location;
};
const locationStringFromEvent = function(event) {
    let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '';
    return locationStringFrom(event.Locations[0], prefix);
};
export const ChildEventLayout = (param)=>{
    let { event, isCancelled } = param;
    var _event_Tickets;
    const eventsConfig = features().events;
    if (eventsConfig == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { noTicketRequired } = eventsConfig.detailPage.copy;
    const hasTickets = ((_event_Tickets = event.Tickets) === null || _event_Tickets === void 0 ? void 0 : _event_Tickets.length) > 0;
    const { date, time } = formatDatesOverview(event);
    const dateTime = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "edition__date",
                children: date
            }),
            time && /*#__PURE__*/ _jsx("span", {
                className: "edition__time",
                children: time
            })
        ]
    });
    return /*#__PURE__*/ _jsxs("li", {
        className: "edition",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "edition__when",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "sr-text",
                        children: "Waar en wanneer: "
                    }),
                    /*#__PURE__*/ _jsx("time", {
                        dateTime: moment(event.Start).format('YYYY-MM-DDTHH:mm'),
                        children: isCancelled ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("del", {
                                    children: dateTime
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "edition__status",
                                    children: "Geannuleerd"
                                })
                            ]
                        }) : dateTime
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "edition__body",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "edition__header",
                        children: [
                            event.Title && /*#__PURE__*/ _jsx("h4", {
                                className: "edition__title",
                                children: event.Title
                            }),
                            event.Subtitle && /*#__PURE__*/ _jsx("span", {
                                className: "edition__subtitle label--xs",
                                children: event.Subtitle
                            })
                        ]
                    }),
                    event.HeaderText && /*#__PURE__*/ _jsx(Text, {
                        ...event.HeaderText,
                        className: "edition__text"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "edition__meta",
                        children: [
                            event.Locations.length > 0 && /*#__PURE__*/ _jsxs("address", {
                                children: [
                                    /*#__PURE__*/ _jsx("svg", {
                                        className: "edition__icon",
                                        width: "15",
                                        height: "18",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--location"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: event.Locations.map((l)=>l.Name).join(', ')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "edition__price",
                                children: [
                                    /*#__PURE__*/ _jsx("svg", {
                                        className: "edition__icon",
                                        width: "16",
                                        height: "16",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--price"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: priceLines(event, noTicketRequired).join(' / ')
                                    })
                                ]
                            })
                        ]
                    }),
                    hasTickets && !isCancelled && /*#__PURE__*/ _jsx("div", {
                        className: "edition__signup",
                        children: /*#__PURE__*/ _jsx(ItemTickets, {
                            ...event,
                            className: "event__tickets--row"
                        })
                    })
                ]
            })
        ]
    });
};
